import { Capacitor } from '@capacitor/core';
import { ADMIN_2FA_HEADER } from '../shared/adminEmail2fa';

export const ADMIN_2FA_STORAGE_KEY = 'pacarion_admin_2fa_token';

let memoryToken = '';

function nativeApp() {
  return !!(
    Capacitor
    && typeof Capacitor.isNativePlatform === 'function'
    && Capacitor.isNativePlatform()
  );
}

function readStoredToken() {
  if (!nativeApp()) return '';
  if (memoryToken) return memoryToken;
  try {
    memoryToken = sessionStorage.getItem(ADMIN_2FA_STORAGE_KEY) || '';
  } catch (error) {
    memoryToken = '';
  }
  return memoryToken;
}

export function rememberAdminEmailToken(token) {
  if (!nativeApp()) return;
  const value = String(token || '').trim();
  if (!value) return;
  memoryToken = value;
  try {
    sessionStorage.setItem(ADMIN_2FA_STORAGE_KEY, value);
  } catch (error) {
    // The in-memory copy still covers this page.
  }
}

export function clearAdminEmailToken() {
  memoryToken = '';
  try {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem(ADMIN_2FA_STORAGE_KEY);
    }
  } catch (error) {
    // Memory is already empty.
  }
}

export function adminEmailSessionHeader() {
  const token = readStoredToken();
  if (!token) return {};
  return { [ADMIN_2FA_HEADER]: token };
}

export function noteAdminEmailStatus(status) {
  if (Number(status) === 401) clearAdminEmailToken();
}
